import { PREVIEW_NS, type PreviewFont, type PreviewFontFit } from "@innoclouds/ui";
import type { FontFitReport } from "../utils/fontFit";
import { previewFonts } from "../utils/localFonts";
import { postToPreview, previewTile } from "./mode";

const HIGHLIGHT_STYLE_ID = "inno-preview-highlight";

export const highlight = (screen: string | null, element: string | null) => {
	let style = document.getElementById(HIGHLIGHT_STYLE_ID);
	if (!element) {
		style?.remove();
		return;
	}
	if (!style) {
		style = document.createElement("style");
		style.id = HIGHLIGHT_STYLE_ID;
		document.head.appendChild(style);
	}
	const byScreen = screen ? `[data-screen="${CSS.escape(screen)}"]` : "";
	style.textContent = `${byScreen}[data-el="${CSS.escape(element)}"] { outline: 3px dashed #ff6a00 !important; outline-offset: -3px !important; }`;
};

// snapdom переносит правила из <style> в снимок даже у отключённого стиля, поэтому на время снимка правило убираем
export const withoutHighlight = async <T>(run: () => Promise<T>) => {
	const style = document.getElementById(HIGHLIGHT_STYLE_ID);
	const css = style?.textContent ?? "";
	if (style) style.textContent = "";
	try {
		return await run();
	} finally {
		if (style?.isConnected && style.textContent === "") style.textContent = css;
	}
};

const fitOf = (report: FontFitReport | null): PreviewFontFit | null =>
	report && {
		reference: report.reference,
		verdict: report.verdict,
		worst: report.worst,
		deviations: report.deviations.map(({ metric, percent }) => ({ metric, percent })),
		ratios: report.ratios,
	};

export const applyFont = async (font: PreviewFont | null) => {
	const { main, families } = await previewFonts(font);
	if (previewTile) return;
	postToPreview({
		ns: PREVIEW_NS,
		type: "font-report",
		loaded: main?.loaded ?? [],
		failed: main?.failed ?? [],
		app: fitOf(main?.fit ?? null),
		families,
	});
};
